module.exports = __webpack_public_path__ + "img/signup-guide-04-02.f9ae0690.png";